module.exports = __webpack_public_path__ + "static/media/image_21.45b9c6bb.png";